import FlexSearch from 'flexsearch';

export default class FlexSearchAdapter {
	items;

	constructor(options) {
		this.options = options;
	}

	setTransactions(list) {
		const options = this.options;
		this.items = list;
		const createOptions = {
			// default values:
			encode: "balance",
			tokenize: "forward",
			threshold: 0,
			async: false,
			worker: false,
			cache: false,
		};
		this.searcher = FlexSearch.create(createOptions);

		for(let index = 0; index < this.items.length; index++) {
			const item = this.items[index];
			const searchableItem = {};
			for(let key of options.keys) {
				searchableItem[key] = item[key];
			}
			this.searcher.add(index, searchableItem.name);
		}
	}

	async search(query) {
		return new Promise((resolve, reject) => {
			this.searcher.search(query, 100, (results) => {
				results = results.map((result) => {
					return this.items[result].transaction;
				});
				resolve(results);
			});
		});
	}

}